import { render, staticRenderFns } from "./AddAndAssignNewUserDrawer.vue?vue&type=template&id=fb1ebfa0&scoped=true&"
import script from "./AddAndAssignNewUserDrawer.vue?vue&type=script&lang=js&"
export * from "./AddAndAssignNewUserDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AddAndAssignNewUserDrawer.vue?vue&type=style&index=0&id=fb1ebfa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1ebfa0",
  null
  
)

export default component.exports